'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Notification = require('../../managewidgets/components/notification/Notification');

var _ScreenMessageContainer = require('./ScreenMessageContainer');

var _ScreenMessageContainer2 = _interopRequireDefault(_ScreenMessageContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = function isEmpty(messages) {
  return !messages || !messages.length;
};

/** @type { React.StatelessComponent } */
var ScreenMessagePanel = function ScreenMessagePanel(props) {

  var getScreenMessages = function getScreenMessages(screenMessages, status) {
    var messages = [];

    if (screenMessages) {
      screenMessages.forEach(function (screenMessage) {
        messages.push(_react2.default.createElement(_ScreenMessageContainer2.default, {
          screenKey: props.screenKey,
          status: status,
          message: screenMessage.message,
          subMessages: screenMessage.subMessages,
          key: screenMessage.message.value
        }));
      });
    }

    return messages;
  };

  if (isEmpty(props.errorMessages) && isEmpty(props.warningMessages) && isEmpty(props.successfulMessages) && isEmpty(props.infoMessages)) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: props.className, style: props.style },
    getScreenMessages(props.errorMessages, _Notification.NotificationStatus.ERROR),
    getScreenMessages(props.warningMessages, _Notification.NotificationStatus.WARNING),
    getScreenMessages(props.successfulMessages, _Notification.NotificationStatus.SUCCESSFUL),
    getScreenMessages(props.infoMessages, _Notification.NotificationStatus.INFORMATIONAL)
  );
};

ScreenMessagePanel.propTypes = {
  screenKey: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  errorMessages: _propTypes2.default.array,
  warningMessages: _propTypes2.default.array,
  successfulMessages: _propTypes2.default.array,
  infoMessages: _propTypes2.default.array
};

exports.default = ScreenMessagePanel;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screenmessage/ScreenMessagePanel.js
// module id = 759
// module chunks = 10